(function() {
  var form = document.getElementById('xc-filter-form');
  var collectionUrl = (window.xcCollection && window.xcCollection.url) || window.location.pathname;

  // Form submit handler
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var url = new URL(collectionUrl, window.location.origin);
      var formData = new FormData(form);

      formData.forEach(function(value, key) {
        // Skip empty values
        if (!value || value === '' || value === '0') return;

        // Handle price inputs - convert to cents/pence
        if (key.includes('price.gte') || key.includes('price.lte')) {
          var numVal = parseFloat(value);
          if (isNaN(numVal) || numVal <= 0) return; // Skip invalid or zero price
          value = numVal * 100;
        }

        url.searchParams.append(key, value);
      });

      window.location.href = url.toString();
    });
  }

  // Dropdown toggle with mobile overlay
  var filterOverlay = document.querySelector('.xc-filter-overlay');
  function closeAllDropdowns() {
    document.querySelectorAll('.xc-dropdown.open').forEach(function(d) {
      d.classList.remove('open');
    });
    if (filterOverlay) filterOverlay.classList.remove('active');
  }

  document.querySelectorAll('.xc-dropdown__trigger').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var dropdown = this.closest('.xc-dropdown');
      var isOpen = dropdown.classList.contains('open');
      closeAllDropdowns();
      if (!isOpen) {
        dropdown.classList.add('open');
        if (window.innerWidth <= 768 && filterOverlay) {
          filterOverlay.classList.add('active');
        }
      }
    });
  });

  // Close on overlay click
  if (filterOverlay) {
    filterOverlay.addEventListener('click', function() {
      closeAllDropdowns();
      xcCloseMobileSheet();
    });
  }

  // Mobile filter sheet — built by moving the desktop filter lists into it.
  // .xc-filter-bar__left is display:none below 769px, so the controls are not
  // needed in two places; moving them keeps a single source of truth and avoids
  // submitting every active filter twice.
  var xcMovedLists = [];
  function xcBuildMobileSheet() {
    var body = document.getElementById('xc-mobile-sheet-body');
    if (body && body.children.length) return;
    var source = document.querySelector('.xc-filter-bar__left');
    if (!body || !source) return;

    source.querySelectorAll('.xc-dropdown').forEach(function(dd) {
      var trigger = dd.querySelector('.xc-dropdown__trigger');
      var list = dd.querySelector('.xc-dropdown__menu-list');
      if (!trigger || !list) return;

      var firstNode = trigger.firstChild;
      var label = firstNode && firstNode.nodeType === 3 ? firstNode.nodeValue.trim() : '';
      if (!label) label = 'Filter';
      var badge = trigger.querySelector('.badge-count');

      var group = document.createElement('div');
      group.className = 'xc-mobile-sheet__group' + (badge ? ' open' : '');

      var title = document.createElement('div');
      title.className = 'xc-mobile-sheet__group-title';
      title.appendChild(document.createTextNode(label + (badge ? ' (' + badge.textContent + ')' : '')));
      title.insertAdjacentHTML('beforeend',
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>');
      title.addEventListener('click', function() { group.classList.toggle('open'); });

      var items = document.createElement('div');
      items.className = 'xc-mobile-sheet__group-items';
      items.appendChild(list); // moved, not cloned
      xcMovedLists.push({ list: list, home: dd.querySelector('.xc-dropdown__menu') });

      group.appendChild(title);
      group.appendChild(items);
      body.appendChild(group);
    });
  }

  // Put the lists back so the desktop dropdowns still work after a resize
  function xcCloseMobileSheet() {
    var sheet = document.getElementById('xc-mobile-sheet');
    if (sheet) sheet.classList.remove('active');
    if (filterOverlay) filterOverlay.classList.remove('active');
    xcMovedLists.forEach(function(m) { if (m.home) m.home.appendChild(m.list); });
    xcMovedLists = [];
    var body = document.getElementById('xc-mobile-sheet-body');
    if (body) body.innerHTML = '';
  }

  var mobileBtn = document.getElementById('xc-mobile-filter-btn');
  var mobileSheet = document.getElementById('xc-mobile-sheet');
  var mobileClose = document.getElementById('xc-mobile-sheet-close');
  if (mobileBtn && mobileSheet) {
    mobileBtn.addEventListener('click', function(e) {
      e.preventDefault();
      xcBuildMobileSheet();
      mobileSheet.classList.add('active');
      if (filterOverlay) filterOverlay.classList.add('active');
    });
  }
  if (mobileClose) {
    mobileClose.addEventListener('click', xcCloseMobileSheet);
  }

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.xc-dropdown')) {
      closeAllDropdowns();
    }
  });

  // Close dropdown on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.xc-dropdown.open').forEach(function(d) {
        d.classList.remove('open');
      });
    }
  });
})();

// Helper functions for active filter tags
function removeFilter(paramName, value) {
  var url = new URL(window.location.href);
  var params = url.searchParams.getAll(paramName);
  url.searchParams.delete(paramName);
  params.forEach(function(v) {
    if (v !== value) {
      url.searchParams.append(paramName, v);
    }
  });
  window.location.href = url.toString();
}

function clearPriceFilter() {
  var url = new URL(window.location.href);
  var keysToDelete = [];
  url.searchParams.forEach(function(v, k) {
    if (k.includes('price')) keysToDelete.push(k);
  });
  keysToDelete.forEach(function(k) { url.searchParams.delete(k); });
  window.location.href = url.toString();
}

function clearAllFilters() {
  var c = window.xcCollection || {};
  window.location.href = (c.url || window.location.pathname) + '?sort_by=' + encodeURIComponent(c.sortBy || '');
}

// ─── Lazy variant loading ───────────────────────────────────────────
// Variant options are fetched from templates/product.variants-json.liquid
// instead of being rendered into the page for all 24 cards.
var xcVariantRequests = {};

function xcLoadVariants(wrap) {
  var select = wrap.querySelector('.variant-select');
  if (!select || select.getAttribute('data-variants-loaded') !== 'false') return;
  var handle = wrap.getAttribute('data-product-handle');
  if (!handle) return;

  select.setAttribute('data-variants-loaded', 'loading');
  var placeholder = select.options[0];
  var placeholderText = placeholder ? placeholder.textContent : '';
  if (placeholder) placeholder.textContent = 'Loading options...';

  if (!xcVariantRequests[handle]) {
    xcVariantRequests[handle] = fetch('/products/' + handle + '?view=variants-json').then(function(r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  xcVariantRequests[handle].then(function(product) {
    var frag = document.createDocumentFragment();
    product.variants.forEach(function(v) {
      var o = document.createElement('option');
      o.value = v.id;
      o.textContent = v.t + (v.a ? '' : ' - Sold Out') + ' — ' + v.p;
      if (!v.a) o.disabled = true;
      frag.appendChild(o);
    });
    select.appendChild(frag);
    if (placeholder) placeholder.textContent = placeholderText;
    select.setAttribute('data-variants-loaded', 'true');
  }).catch(function() {
    delete xcVariantRequests[handle];
    select.setAttribute('data-variants-loaded', 'false');
    if (placeholder) placeholder.textContent = placeholderText;
    var link = wrap.querySelector('.variant-view-link');
    if (link) link.textContent = 'Could not load options — view full details →';
  });
}

function xcToggleVariants(btn) {
  var wrap = btn.closest('.variant-dropdown-wrap');
  if (!wrap) return;
  var willOpen = !wrap.classList.contains('open');
  wrap.classList.toggle('open');
  if (willOpen) xcLoadVariants(wrap);
}

// Prefetch on hover / first touch so the dropdown is already filled on click
document.querySelectorAll('.variant-dropdown-wrap').forEach(function(wrap) {
  var prefetch = function() { xcLoadVariants(wrap); };
  wrap.addEventListener('mouseenter', prefetch, { once: true, passive: true });
  wrap.addEventListener('touchstart', prefetch, { once: true, passive: true });
});

// Close variant dropdowns when clicking outside
document.addEventListener('click', function(e) {
  if (!e.target.closest('.variant-dropdown-wrap')) {
    document.querySelectorAll('.variant-dropdown-wrap.open').forEach(function(el) {
      el.classList.remove('open');
    });
  }
});

// AJAX Add to Cart for ALL forms on collection page
document.querySelectorAll('.product-card-actions form[action="/cart/add"]').forEach(function(form) {
  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var variantId = form.querySelector('select[name="id"]')
      ? form.querySelector('select[name="id"]').value
      : form.querySelector('input[name="id"]').value;
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.classList.add('loading');
    btn.textContent = 'Adding...';

    // Close dropdown if variant form
    var dropdownWrap = form.closest('.variant-dropdown-wrap');
    if (dropdownWrap) dropdownWrap.classList.remove('open');

    // Use cart-container.add() method from v2.1 theme
    var cartContainer = document.querySelector('cart-container');
    if (cartContainer && typeof cartContainer.add === 'function') {
      await cartContainer.add({
        items: [{ id: Number(variantId), quantity: 1 }]
      });
    } else {
      // Fallback: AJAX fetch instead of redirect
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });
    }

    btn.classList.remove('loading');
    btn.textContent = originalText;
    btn.disabled = false;
  });
});
